import RecoverPasswordRequest from './RecoverPasswordRequest';

export default RecoverPasswordRequest;
